import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgForward5Fill = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-323.56 -348.44 2311.11 2488.89",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "matrix(1 0 0 -1 0 1536)",
		d: "M45 -115Q26 -134 13.0 -128.0Q0 -122 0 -96V1376Q0 1402 13.0 1408.0Q26 1414 45 1395L755 685Q764 676 768 666V1376Q768 1402 781.0 1408.0Q794 1414 813 1395L1523 685Q1542 666 1542.0 640.0Q1542 614 1523 595L813 -115Q794 -134 781.0 -128.0Q768 -122 768 -96V614Q764 604 755 595Z"
	})
});
export default SvgForward5Fill;
